import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Tooltip, tooltipClasses } from "@mui/material";
import { localizeDocLink } from "helpers/docLink";
import { useTranslation } from "react-i18next";

import variables from "../../../assets/styles/_variables.module.scss";
import styles from "./style.module.scss";

interface ISimpleHelpdeskIcon {
    link: string;
    text?: string;
}

// Helpdesk icon that displays tooltip when hovering (useful when there isn't much space horizontally)
const SimpleHelpdeskIcon = ({ link, text }: ISimpleHelpdeskIcon) => {
    const [t] = useTranslation();

    const handleOpeningArticle = (e: any, link: string) => {
        e.preventDefault();
        window.open(link, "_blank");
    };

    return (
        <Tooltip
            title={text ? text : t("Documentation.AccessDoc")}
            slotProps={{
                tooltip: {
                    sx: {
                        bgcolor: variables["info-light"],
                        color: variables["info"],
                        fontFamily: "Poppins",
                        fontSize: "0.7rem",
                        fontWeight: "400",
                        textAlign: "center",
                    },
                },
                arrow: { sx: { color: variables["info-light"] } },
                popper: {
                    sx: {
                        [`&.${tooltipClasses.popper}[data-popper-placement*="bottom"] .${tooltipClasses.tooltip}`]: {
                            marginTop: "5px",
                        },
                    },
                },
            }}
            arrow
        >
            <button
                className={styles["helpdesk-button"]}
                onClick={(e: any) => handleOpeningArticle(e, localizeDocLink(link))}
            >
                <HelpOutlineIcon className="btn-icon" />
            </button>
        </Tooltip>
    );
};

export default SimpleHelpdeskIcon;
